export { BottomTab } from "./BottomTab"
export type { BottomTabProps } from "./BottomTab"
export { TABS_BY_TYPE } from "./tabRegistry"
export type { TabKey, TabType } from "./tabRegistry"
